import {Wrapper} from "../../components";
import {TiTick} from "react-icons/ti";
import AppStore from "../../assets/AppStore.png";
import PlayStore from "../../assets/PlayStore.png";
import DownloadAppImg from "../../assets/downloadApp.png"

function DownloadApp() {
    const features = [
        {
            title: "7/24 Alım/Satım Yapın!",
            description: "Kripto varlıklarınızı mobil cihazınızdan yönetin."
        },
        {
            title: "Varlıklarınızın Kontrolünü Ele Alın!",
            description: "Sadece sizin erişebileceğiniz fonlarınıza güvenle sahip çıkın."
        },
        {
            title: "Anlık Fiyat Takibi",
            description: "Piyasaları anlık takip edin ve fırsatları kaçırmayın."
        },
        {
            title: "Güvenli İşlemler",
            description: "Gelişmiş güvenlik özellikleriyle güvenle işlem yapın."
        }
    ];
    
    return(
        <div className="bg-dark-backgroundOnDark py-24 relative overflow-hidden">
            {/* Dekoratif arka plan elementleri */}
            <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-10 w-80 h-80 bg-primary/10 rounded-full blur-3xl"></div>
            
            <Wrapper>
                <div className="grid grid-cols-12 items-center gap-8">
                    <div className="md:col-start-1 md:col-end-7 col-start-1 col-end-13 relative z-10">
                        <div className="inline-flex items-center bg-dark-background/80 rounded-full py-1.5 px-4 mb-6">
                            <span className="w-2 h-2 rounded-full bg-primary animate-pulse mr-2"></span>
                            <span className="text-primary text-sm font-medium">Mobil Uygulama</span>
                        </div>
                        
                        <h2 className="text-surface-main font-bold text-3xl md:text-4xl mb-4">
                            Mobil Uygulamalar İle <br/> Anında İşlem Yap!
                        </h2>
                        
                        <p className="text-secondaryTwo text-lg mb-8">
                            GMS Kripto ile ticaret becerilerinizin en iyi şekilde değerlendirildiğinden emin olabilirsiniz.
                            Her an, her yerde kripto dünyasına erişim sağlayın.
                        </p>
                        
                        <div className="space-y-6 mb-10">
                            {features.map((feature, index) => (
                                <div key={index} className="flex items-start gap-4">
                                    <div className="bg-primary/20 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                                        <TiTick className="text-primary text-lg" />
                                    </div>
                                    <div>
                                        <h3 className="text-surface-main font-bold text-lg font-dmsans mb-1">{feature.title}</h3>
                                        <p className="text-secondaryTwo">{feature.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        <div className="flex flex-wrap items-center gap-4">
                            <a href="https://apps.apple.com/tr/app/gmskripto-exchange/id6504996507" target="_blank" rel="noopener noreferrer" className="transform hover:scale-105 transition-transform">
                                <img src={AppStore} alt="App Store" className="h-12" />
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.gmskripto.exchange&hl=tr" target="_blank" rel="noopener noreferrer" className="transform hover:scale-105 transition-transform">
                                <img src={PlayStore} alt="Play Store" className="h-12" />
                            </a>
                        </div>
                    </div>
                    
                    <div className="md:col-start-8 md:col-end-13 col-start-1 col-end-13 hidden md:block relative">
                        {/* Görsel etrafında parlama efekti */}
                        <div className="absolute -inset-4 bg-primary/10 rounded-3xl blur-xl"></div>
                        
                        <div className="relative z-10 bg-dark-background/40 backdrop-blur-sm p-6 rounded-3xl border border-dark-line/30 transform hover:scale-[1.02] transition-transform duration-700">
                            <img src={DownloadAppImg} alt="GMS Kripto Mobile App" className="w-full rounded-2xl" />
                            
                            {/* QR kod alanı */}
                            <div className="absolute bottom-10 right-10 bg-white/90 backdrop-blur-sm p-3 rounded-xl shadow-lg">
                                <div className="w-20 h-20 bg-[url('https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://gmskripto.com')] bg-cover bg-center"></div>
                                <p className="text-dark-background text-xs font-medium text-center mt-1">Uygulamayı İndir</p>
                            </div>
                        </div>
                        
                        {/* Dekoratif elementler */}
                        <div className="absolute top-1/4 -right-4 w-16 h-16 bg-primary/20 rounded-full blur-lg"></div>
                        <div className="absolute bottom-1/3 -left-6 w-12 h-12 bg-primary/30 rounded-full blur-md"></div>
                    </div>
                </div>
            </Wrapper>
        </div>
    )
}

export {DownloadApp};
